import React, { Component } from 'react';
import { ButtonReg } from 'atoms/Buttons';
import Breadcrumb from 'molecules/Breadcrumb';
import CompanyFilter from 'molecules/CompanyFilter';
import DataTables from 'organisms/DataTable';
import { actionFormatter } from 'molecules/TableFormatters';
import { GET_COMPANIES } from 'fixtures/api';
import { NewCompany } from 'fixtures/TemplateData';
import { dashboardCreate, dashboardDelete, dashboardUpdate } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { postNewData, deleteData, putData } from 'services/cmsService';
import { getAllCompaniesData, editCompanyData, addCompanyData } from 'Redux/actions/CompanyListActions';
import { getAllContractorsData } from 'Redux/actions/ContractorListActions';
import { getAllDeptsOptionData } from 'Redux/actions/DepartmentListActions';
import { getAllWorkLocationsData } from 'Redux/actions/WorkLocationListActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageWrapper, TableWrapper } from './styles';
import lo from 'lodash';

import {
  TxtConfirmDeleteCompany,
  TxtSuccessDeleteCompany,
  TxtFailedDeleteDept,
  TxtFailedSubmitData,
  TxtSuccessSubmitCompany
} from 'fixtures/texts';
import ModalPage from 'components/templates/ModalPage/index';
import NewCompanyModal from 'components/organisms/NewCompanyModal';
import CompanyDetail from './CompanyDetail';
import IconPng from 'components/atoms/IconPng/index';

const btnIcons = {
  ic_arrow_down: require('App/assets/images/ic_arrow_down.png'),
  ic_arrow_right: require('App/assets/images/ic_arrow_right.png')
}
export class CompanyList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowModal: false,
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
      companyData: {},
      navList: [
        'Company',
        'Company List'
      ],
      allowCreate: false,
      allowDelete: false,
      allowUpdate: false,
    }

  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getAllCompaniesData()
    this.props.getAllDeptsOptionData()
    this.props.getAllWorkLocationsData()
    this.props.getAllContractorsData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { companiesList, viewState: { isLoading }, userLogin } = this.props
    if (prevProps.companiesList !== companiesList && isLoading) {
      this.props.toggleIsLoading(false)
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
  }

  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, dashboardCreate),
        allowDelete: permissionCheck(permissions, dashboardDelete),
        allowUpdate: permissionCheck(permissions, dashboardUpdate),
      })
    }
  }

  // method for deleting department
  async onDeleteDept(dept) {
    const isOk = window.confirm(TxtConfirmDeleteCompany)
    if (isOk) {
      const uri = `${GET_COMPANIES}/${dept.id}`
      try {
        const res = await deleteData(uri)
        if (res.status !== 500) {
          alert(TxtSuccessDeleteCompany)
          this.props.getAllCompaniesData()
        } else {
          throw res
        }
      } catch (error) {
        alert(TxtFailedDeleteDept)
      }
    }
  }

  // change company data state
  onChangeCompanyData(val, field) {
    let company = Object.assign(this.state.companyData)
    company[field] = val
    this.setState({ companyData: company })
  }

  // method for adding new company
  addNewCompany() {
    this.switchModal(lo.cloneDeep(NewCompany))
  }

  // method for submitting department
  async onSubmitCompany() {
    const company = lo.cloneDeep(this.state.companyData)

    const uri = company.hasOwnProperty('createdAt') ?
      `${GET_COMPANIES}/${company.id}` :
      GET_COMPANIES

    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        const { name, code } = company
        const form = {
          name,
          code,
          workLocationId: company.workLocationId === '-' ? null : company.workLocationId,
          contractorIds: company.contractors.map(d => ({
            id: d.id,
            isActive: d.CompanyContractor.isActive
          })),
          departmentIds: company.departments.map(d => d.id),
        }
        console.log(form, company)
        const res = company.hasOwnProperty('createdAt') ?
          await putData(uri, form) :
          await postNewData(uri, form)

        if (res.status === 201 || res.status === 204 || res.status === 200) {
          alert(TxtSuccessSubmitCompany)
          this.setState({ isSubmitDisabled: false })
          this.props.getAllCompaniesData()
          this.switchModal(NewCompany)
        } else {
          throw res
        }
      } catch (err) {
        alert(TxtFailedSubmitData)
        this.setState({ isSubmitDisabled: false })
      }
    })
  }

  switchModal(companyData) {
    const { isShowModal } = this.state
    this.setState({ companyData: companyData }, () => {
      this.setState({ isShowModal: !isShowModal })
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const { isShowModal, isSubmitDisabled, isError, companyData, navList } = this.state
    const { companiesList, settingsTable, viewState: { isLoading, isMobileView } } = this.props

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const config = [
      {
        dataField: 'name',
        text: 'Company Name',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        editorStyle: (cell, row, rowIndex, colIndex) => {
          return { fontSize: '12px', padding: '0px 9px', maxHeight: '25px' };
        },
        sort: true
      },
      {
        dataField: 'code',
        text: 'Company Code',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        editorStyle: (cell, row, rowIndex, colIndex) => {
          return { fontSize: '12px', padding: '0px 9px', maxHeight: '25px' };
        },
        sort: true
      },
      {
        dataField: 'workLocation.name',
        text: 'Work Location',
        headerAttrs: { width: isMobileView ? 150 : 200 },
        editorStyle: (cell, row, rowIndex, colIndex) => {
          return { fontSize: '12px', padding: '0px 9px', maxHeight: '25px' };
        },
        sort: true
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerAttrs: { width: isMobileView ? 80 : 100 },
        formatter: actionFormatter,
        formatExtraData: {
          allowEdit: this.state.allowUpdate,
          allowDel: this.state.allowDelete,
          edit: (row) => this.switchModal.bind(this, row),
          del: (row) => this.onDeleteDept.bind(this, row),
        },
        isDummyField: true
      }
    ]

    const expandRow = {
      className: 'mx-0 px-0 bg-white',
      renderer: row => (
        <CompanyDetail
          {...{row, isMobileView}}
        />
      ),
      showExpandColumn: true,
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <IconPng srcIcon={btnIcons.ic_arrow_down} showPointer={true} mx={'8px'} size={'auto'} h={'7'} />
          );
        }
        return (
          <IconPng srcIcon={btnIcons.ic_arrow_right} showPointer={true} mx={'8px'} size={'auto'} h={'11'}/>
        );
      }
    };

    return (
      <PageWrapper isMobile={isMobileView}>
        <Breadcrumb navList={navList}>
          <CompanyFilter />
        </Breadcrumb>
        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <NewCompanyModal
              fnChange={this.onChangeCompanyData.bind(this)}
              fnSubmit={this.onSubmitCompany.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              companyData={companyData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              isMobileView={isMobileView}
              {...this.props}
            />
          }
        />
        {!isLoading &&
          <TableWrapper>
            <DataTables
              minWidth={'700px'}
              leftSlot={
                this.state.allowCreate &&
                <ButtonReg
                  btnTxt={'Add'}
                  disabled={false}
                  onClick={() => this.addNewCompany()}
                  width={'78px'}
                />
              }
              expandRow={expandRow}
              isMobile={isMobileView}
              dataList={companiesList}
              columnConfig={config}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
          </TableWrapper>
        }
      </PageWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    companiesList: state.companiesList,
    deptsList: state.deptsList,
    workLocationsList: state.workLocationsList,
    contractorsList: state.contractorsList,
    userLogin: state.userLogin,
    viewState: state.viewState,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getAllDeptsOptionData,
      getAllContractorsData,
      getAllCompaniesData,
      getAllWorkLocationsData,
      editCompanyData,
      addCompanyData,
      toggleIsLoading,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyList);
